import React, { useState,useEffect } from 'react';
import Modal from 'react-bootstrap/Modal'
import { Page } from "react-pdf";
import { Document } from 'react-pdf/dist/esm/entry.webpack';
export default function PdfModal(props) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  useEffect(() => {
    if(props.show){
      document.body.classList.add("showModal");
    }
    setPageNumber(1)
  }, [props.url,props.show])
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  const previousPage = () => changePage(-1);

  const nextPage = () => changePage(1);

  const changePage = (offset) => { setPageNumber((pageNumber + offset || 1)) };
  return (
    
    <div class={props.show ? "jblListModal modalHere" : "jblListModal"}>
        <div class="jblListModal_Content jblListModal_Content30">
          <div class="jblListModal_header">
            <span class="close" onClick={() => {document.body.classList.remove("showModal");props.onHide()}}>&times;</span>
          </div>
          <div class="jblListModal_Body">
          <Document
          file={{ url: props.cross ? "https://cors-anywhere.herokuapp.com/" + props.url : props.url }}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={console.error}
        >
          <Page pageNumber={pageNumber} />
          <div class="page-controls"> <button
            disabled={pageNumber <= 1}
            onClick={previousPage}
            type="button"
          >‹</button><span>{pageNumber} of {numPages}</span>  <button
            disabled={pageNumber >= numPages}
            onClick={nextPage}
            type="button"
          >›</button></div>
        </Document>
          </div>
        </div>
     
        <div class={props.show ? "modal-backdrop fade show" : "modal-backdrop fade"}  onClick={() => {document.body.classList.remove("showModal");props.onHide()}}></div>
      </div>
     
    
  );
}